"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgRefreshClockFill = function SvgRefreshClockFill(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 18 16",
    stroke: "#4D4D4D",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.006 14a6.003 6.003 0 0 0 6.007-6c0-3.314-2.69-6-6.007-6A6.003 6.003 0 0 0 3 8c0 3.314 2.69 6 6.006 6Z",
    fill: "#F8E71C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.013 8c0-3.314-2.69-6-6.007-6a6.008 6.008 0 0 0-5.57 3.75M3 8c0 3.314 2.69 6 6.006 6a6.008 6.008 0 0 0 5.462-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.29 10.441 1.476-2.413 2.413 1.475m11.759-3.457-1.572 2.35-2.351-1.572m-6.21-1.777L9.283 8.44h3.029"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgRefreshClockFill);
var _default = exports["default"] = Memo;